import {getData} from './redux_data';
import {
    GET_ZONAIVA_CENTRO, MODIFY_ZONAIVA_CENTRO, ADD_ZONAIVA_CENTRO, REMOVE_ZONAIVA_CENTRO, GET_TIPOSZONASIVA_CENTRO
} from '../constants/action_types';

export function getZonaIvaCentro(centroId) {
    return getData('vcentrozonaiva?centro_id=' + centroId, GET_ZONAIVA_CENTRO);
};

export function modifyZonaIvaCentro(tipozonaiva) {
    return (dispatch, getState) => {
        dispatch({ type: MODIFY_ZONAIVA_CENTRO, payload: tipozonaiva });
    };
};

export function addZonaIvaCentro(tipozonaiva) {
    return (dispatch, getState) => {
        dispatch({ type: ADD_ZONAIVA_CENTRO, payload: tipozonaiva });
    };
};

export function removeZonaIvaCentro(tipozonaiva) {
    return (dispatch, getState) => {
        dispatch({ type: REMOVE_ZONAIVA_CENTRO, payload: tipozonaiva });
    };
};

//para el selectoption del new o edit dialog:
export function getTiposZonasIva() {
    return getData('cvtipozonaivas', GET_TIPOSZONASIVA_CENTRO);
};